import * as React from 'react';
import { useSelector } from 'react-redux';
import { DescriptionMobile } from './components';
import { selectAgent } from '../../../selectors/selectAgent';

interface IProps {
  className?: string;
}

export const DescriptionMobileContainer: React.FunctionComponent<React.PropsWithChildren<IProps>> = ({ className }) => {
  const agent = useSelector(selectAgent);

  if (!agent?.description) {
    return null;
  }

  return <DescriptionMobile text={agent.description} className={className} />;
};
